import React, { useEffect, useState } from 'react'
import { connect, useDispatch } from 'react-redux'
import { RootState } from 'Store'
import { Col, Image, message, Row, Space, Statistic } from 'antd'
import { PrimaryButton } from 'Components/button'
import { formatDateTime, getCategoriesName, numberWithComma } from 'helpers/format'
import {
  BomDetailReq,
  DetailReq,
  MeterialBomReq,
  ProductOptionBomReq,
  ProductOptionsWithMaterail,
  UpdateProductBomReq,
} from 'Store/product/types'
import { getBomDetailAPI, getProductDetailAPI, updateProductBomAPI } from 'Store/product/api'
import {
  selectActionEvent,
  selectBomDetail,
  selectBomDetailEvent,
  selectDetail,
  selectDetailEvent,
} from 'Store/product/selector'
import { selectCurrentUser } from 'Store/user/selector'
import EventModal from 'Components/modal/EventModal'
import { clearEventAction } from 'Store/product/actions'
import LoadingView from 'Components/modal/LoadingView'
import { DetailDrawer } from 'Components/common/MainLayout'
import styled from 'styled-components'
import { MyTheme } from 'Components/common/Theme'
import { ConfirmDailog } from 'Components/modal'
import { selectDatas as selectDeliveryDatas } from 'Store/delivery-cost/selector'
import { selectIsPackageC } from 'Store/pos/selector'
import { ShoppingCartOutlined } from '@ant-design/icons'
import { appConfig } from 'config'
import ProductsTable from './components/ProductsTable'
import { cloneDeep } from 'lodash'
import { ImageFallback } from 'helpers/constanst'

type Props = ReduxProps & {
  visible: boolean
  onCloseDrawer: () => void
  onSuccess?: () => void
  mode: any
  id?: number
}

const AdjustMaterial: React.FunctionComponent<Props> = props => {
  const {
    onCloseDrawer,
    visible,
    currentUser,
    event,
    onSuccess = () => {},
    id = 0,
    mode,
    detail,
    detailEvent,
    bomDetail,
  } = props
  const isCreateMode = mode === 'create'

  const [confirmRequestDialog, setConfirmRequestDialog] = useState(false)
  const [data, setData] = useState([] as ProductOptionsWithMaterail[])
  const dispatch = useDispatch()

  useEffect(() => {
    if (visible && !isCreateMode && id > 0) {
      onGetDetail()
      onGetBomDetail()
    }
  }, [visible])

  useEffect(() => {
    if (bomDetail && bomDetail.length > 0) {
      const originData: ProductOptionsWithMaterail[] = []
      for (let i = 0; i < bomDetail.length; i++) {
        originData.push({
          ...cloneDeep(bomDetail[i]),
          key: i.toString(),
        })
      }
      setData([...originData])
    }
  }, [bomDetail])

  const onGetDetail = (): void => {
    const req: DetailReq = {
      id,
      is_admin: true,
    }
    dispatch(getProductDetailAPI(req, currentUser.accessToken))
  }

  const onGetBomDetail = (): void => {
    const req: BomDetailReq = {
      product_id: id,
    }
    dispatch(getBomDetailAPI(req, currentUser.accessToken))
  }

  const formatMaterialUpdateReq = (data: ProductOptionsWithMaterail[]) => {
    const req = [] as MeterialBomReq[]
    data &&
      data.forEach(item => {
        const option = {
          product_option_id: item.product_option_id || 0,
          product_id: item.product_id,
          bom_qty: item.bom_qty,
        } as MeterialBomReq
        req.push(option)
      })
    return req
  }

  const formatUpdateReq = () => {
    const req = [] as ProductOptionBomReq[]
    data &&
      data.forEach(item => {
        const option = {
          product_option_id: item.product_option_id || 0,
          materials: formatMaterialUpdateReq(item.materials || []),
        } as ProductOptionBomReq
        req.push(option)
      })
    return req
  }

  const validateInput = () => {
    let isValid = true
    data &&
      data.forEach((item: ProductOptionsWithMaterail): false | true => {
        const hasNullBom = item?.materials && item.materials.find(mat => (mat?.bom_qty || 0) <= 0)
        if (hasNullBom) {
          isValid = false
        }
        return isValid
      })

    return isValid
  }

  const onUpdate = (): void => {
    const req: UpdateProductBomReq = {
      product_id: id,
      product_options: formatUpdateReq(),
    }
    dispatch(updateProductBomAPI(req, currentUser.accessToken))
  }

  const onClickUpdate = () => {
    if (!validateInput()) {
      message.error('กรุณาระบุจำนวนที่ใช้ตัดสต๊อกให้ถูกต้อง')
      return
    }
    onOpenConfirmRequestUpdate()
  }

  const onUpdateData = (option: ProductOptionsWithMaterail, materials: ProductOptionsWithMaterail[]) => {
    const newData = cloneDeep(data)
    newData.map(item => {
      if (option.product_option_id === item.product_option_id) {
        item.materials = materials
      }
      return item
    })
    setData([...newData])
  }

  const clearEvent = (): void => {
    dispatch(clearEventAction())
  }

  const onEventSuccess = (): void => {
    clearEvent()
    onSuccess()
    onCloseConfirmRequestUpdate()
  }

  const onCloseConfirmRequestUpdate = () => {
    setConfirmRequestDialog(false)
  }

  const onOpenConfirmRequestUpdate = () => {
    setConfirmRequestDialog(true)
  }

  const FooterContent = (
    <Space size="middle" align="baseline">
      <PrimaryButton text="ยกเลิก" btnType="Cancel" onClick={onCloseDrawer} />
      <PrimaryButton text="บันทึกข้อมูล" onClick={onClickUpdate} />
    </Space>
  )

  const renderInfo = (title: string, value: any, span: number = 15) => {
    return (
      <Row justify="space-between">
        <Col>
          <InfoTitle>{title}</InfoTitle>
        </Col>
        <Col span={span} offset={1}>
          <InfoValue>{value || '-'}</InfoValue>
        </Col>
      </Row>
    )
  }

  const renderImage = (photo: any) => (
    <ThumbImage src={appConfig.assetCdnEndpoint + photo} fallback={ImageFallback} />
  )

  const title = (
    <>
      <Row justify="start" gutter={16} align="middle">
        <Col>จัดการส่วนประกอบสินค้า : {detail?.title}</Col>
      </Row>
      <Row>
        <Col>
          <Description>รหัสสินค้า {detail?.id}</Description> &nbsp;
          <Description>วันที่สร้าง {formatDateTime(detail?.created_at || '')}</Description>
        </Col>
      </Row>
    </>
  )

  const ConfirmRequestUpdate = (
    <ConfirmDailog
      title={'ยืนยันการแก้ไขส่วนประกอบ'}
      description={
        'สต๊อกของสินค้าจะเปลี่ยนแปลงตามจำนวนส่วนประกอบที่ใช้งาน คุณแน่ใจที่จะแก้ไขข้อมูลส่วนประกอบหรือไม่?'
      }
      isShow={confirmRequestDialog}
      handleOk={onUpdate}
      handleCancel={onCloseConfirmRequestUpdate}
      loading={event.IsLoading}
      confirmBtnTxt="ยืนยัน"
    />
  )

  const calculateReserveStock = (materials: ProductOptionsWithMaterail[]) => {
    const stocks = [] as number[]
    materials &&
      materials.forEach(item => {
        const bomQty = item.bom_qty || 1
        const val = Math.floor(item.stock / bomQty)
        stocks.push(val)
      })
    return materials && materials.length > 0 ? Math.min(...stocks) : 0
  }

  return (
    <DetailDrawer
      title={title}
      onCloseDrawer={onCloseDrawer}
      visible={visible}
      footer={FooterContent}
      width={'85%'}
    >
      <LoadingView isShow={detailEvent.IsLoading} />
      <EventModal
        event={[event]}
        enable={visible}
        successCalback={onEventSuccess}
        errorCalback={clearEvent}
      />
      <Row justify="space-between" gutter={[16, 8]}>
        <Col md={12} xs={24}>
          <Title>รายละเอียดสินค้า</Title>
          {renderInfo('ชื่อสินค้า', detail?.title)}
          {renderInfo('รหัสสินค้า', detail?.code)}
          {renderInfo('หน่วย', detail?.uom?.name)}
        </Col>
        <Col md={12} xs={24}>
          {renderInfo('หมวดหมู่สินค้า', getCategoriesName(detail))}
          {renderInfo('รุ่น', detail?.model)}
          {renderInfo('รายละเอียดสินค้า', detail?.details)}
        </Col>
      </Row>
      <br />
      <ProductTitle>ตัวเลือกสินค้า</ProductTitle>
      <br />
      <Row justify="space-between" gutter={[16, 8]}>
        <Col md={24} xs={24}>
          <Row gutter={[8, 8]}>
            {data.map((item, index) => {
              return (
                <Col key={index}>
                  <BoxWrapper>
                    <Row align="top" gutter={[8, 8]} justify="space-between">
                      <Col>
                        <Space size={'small'}>
                          {renderImage(item.photo)}
                          <ProductTitle>{item.title}</ProductTitle>
                        </Space>
                      </Col>
                      <Col>
                        <Statistic
                          title="สต๊อก (การคำนวนการผลิตโดยประมาน)"
                          value={calculateReserveStock(item.materials || [])}
                          prefix={<ShoppingCartOutlined />}
                          suffix={<Description>{detail?.uom?.name || ''}</Description>}
                          formatter={(val: any) => numberWithComma(val || 0)}
                        />
                      </Col>
                      <Col span={24}>
                        <ProductsTable
                          products={item.materials || []}
                          onUpdateData={(product: ProductOptionsWithMaterail[]) => {
                            onUpdateData(item, product)
                          }}
                        />
                      </Col>
                    </Row>
                  </BoxWrapper>
                </Col>
              )
            })}
          </Row>
        </Col>
      </Row>
      {ConfirmRequestUpdate}
    </DetailDrawer>
  )
}

const Title = styled.div`
  font-family: ${(props: { theme: MyTheme }): string => props.theme.fontFamily.bold};
  font-weight: 500;
`

const ProductTitle = styled.div`
  font-family: ${(props: { theme: MyTheme }): string => props.theme.fontFamily.bold};
  font-weight: 500;
  font-size: ${(props: { theme: MyTheme }): string => props.theme.typography.h5};
`

const Description = styled.span`
  font-family: ${(props: { theme: MyTheme }): string => props.theme.fontFamily.primary};
  font-size: ${(props: { theme: MyTheme }): string => props.theme.typography.body4};
  color: ${(props: { theme: MyTheme }): string => props.theme.colors.grey};
`

const InfoTitle = styled.span`
  font-size: ${(props: { theme: MyTheme }): string => props.theme.typography.body4};
  color: ${(props: { theme: MyTheme }): string => props.theme.colors.grey};
`

const InfoValue = styled.span`
  font-size: ${(props: { theme: MyTheme }): string => props.theme.typography.body4};
  color: ${(props: { theme: MyTheme }): string => props.theme.colors.black};
`

const BoxWrapper = styled.div`
  width: 100%;
  border-radius: 10px;
  padding: 15px 10px;
  //border: 1px solid ${(props: { theme: MyTheme }): string => props.theme.colors.whitebg};
  border: 1px solid #f0f0f0;
  background-color:  ${(props: { theme: MyTheme }): string => props.theme.colors.white};
`

const ThumbImage = styled(Image)`
  border-radius: 5px;
  width: 70px;
  height: 70px;
  object-fit: cover;
`

const mapStateToProps = (state: RootState) => {
  return {
    currentUser: selectCurrentUser(state),
    event: selectActionEvent(state),
    detail: selectDetail(state),
    detailEvent: selectDetailEvent(state),
    deliveryCost: selectDeliveryDatas(state),
    isPackageC: selectIsPackageC(state),
    bomDetail: selectBomDetail(state),
    bomDetailEvent: selectBomDetailEvent(state),
  }
}

type ReduxProps = ReturnType<typeof mapStateToProps>

export default connect(mapStateToProps)(AdjustMaterial)
